import MenuCategories from './MenuCategories';
import './style.scss';

export default MenuCategories;
